export const GROUP_STATUS_MIXED = 'MIXED';

/** Derive a single status for a group; MIXED when items differ. */
export function deriveGroupStatus(items) {
  if (!items.length) return GROUP_STATUS_MIXED;
  const statuses = [...new Set(items.map((i) => i.status))];
  return statuses.length === 1 ? statuses[0] : GROUP_STATUS_MIXED;
}

/** Group return requests by orderId (falls back to request id when orderId missing). */
export function groupReturnsByOrderId(requests) {
  const map = new Map();
  for (const req of requests) {
    const key = req.orderId || req.id;
    if (!map.has(key)) map.set(key, []);
    map.get(key).push(req);
  }

  return Array.from(map.entries())
    .map(([orderId, items]) => {
      const sorted = [...items].sort((a, b) => a.id.localeCompare(b.id));
      const totalCredit = sorted.reduce((sum, r) => sum + (r.creditAmount || 0), 0);
      const totalQty = sorted.reduce((sum, r) => sum + (r.qty || 0), 0);
      return {
        orderId,
        items: sorted,
        isBulk: sorted.length > 1,
        totalCredit,
        totalQty,
        customerName: sorted[0].customerName,
        customerPhone: sorted[0].customerPhone,
        status: deriveGroupStatus(sorted),
        deliveryPersonName: sorted[0].deliveryPersonName,
        deliveryPersonSub: sorted[0].deliveryPersonSub,
      };
    })
    .sort((a, b) => {
      const aTime = a.items[0]?.requestedAt || '';
      const bTime = b.items[0]?.requestedAt || '';
      return bTime.localeCompare(aTime);
    });
}

export function itemsShareStatus(items, status) {
  return items.length > 0 && items.every((i) => i.status === status);
}

/** Items in a group that can receive (or retry) rider assignment. */
export function itemsAssignableForRider(items, assignableStatuses) {
  return items.filter((i) => assignableStatuses.includes(i.status));
}
